import { LoginSteps } from '../../model/types';
import { LOGIN_STEP_KEY } from './constants';

/* Save login step value to storage */
export const getLoginStepFromStorage = () => {
    const step = localStorage.getItem(LOGIN_STEP_KEY);
    const isValidStep = Object.values(LoginSteps).includes(step as LoginSteps);
    if (isValidStep) {
        return step as LoginSteps;
    }
    return LoginSteps.Login;
};

export const setLoginStepToStorage = (value: LoginSteps) => {
    return localStorage.setItem(LOGIN_STEP_KEY, value);
};
